import * as React from "react";
import {useEffect, useState} from "react";
import {InputFieldState} from "./InputFieldState";
import {CheckBox} from "./CheckBox";

type CheckboxMultiOption = { key: string, value: string }

type CheckboxMultiProps = {
    label: string;
    options: CheckboxMultiOption[];
    onChange: (value: string) => void;
    state: InputFieldState
}


export const CheckboxMulti = ({label, options, onChange, state}: CheckboxMultiProps) => {

    const optionStates: any = {};

    const [showInput, setShowInput] = useState(false);
    const [inputValue, setInputValue] = useState('');

    options.map(option => {
        optionStates[option.key] = useState<InputFieldState>({value: '', isChecked: false});
    });


    let optionGetters: any = [];
    Object.keys(optionStates).map((key: string) => {
        optionGetters.push(optionStates[key][0]);
    });

    useEffect(() => {
        getValue();
    }, [...optionGetters, inputValue]);

    useEffect(() => {
        if (typeof state.value === "string" && state.value.length > 1) {
            const value = JSON.parse(state.value);

            if (value) {
                if (inputValue != value.otherValue) {
                    setInputValue(value.otherValue);
                    setShowInput(value.otherValue.length > 0);
                }

                Object.keys(value.options).map(id => {
                    let option: { value: string, isChecked: boolean } = value.options[id];
                    if (optionStates[id][0].isChecked !== option.isChecked) {
                        optionStates[id][1]({value: option.value, isChecked: option.isChecked});
                    }


                });
            }
        }
    }, [state])


    const onChangeListener = (option: CheckboxMultiOption, value: string, isChecked: boolean) => {
        optionStates[option.key][1]({value: value, isChecked: isChecked});
        if (option.key == 'other-value') {
            setShowInput(isChecked);
            if (!isChecked) {
                setInputValue('');
            }
        }
    }

    const getValue = () => {
        let json: any = {
            options: {},
            otherValue: inputValue,
        }
        options.map(option => {
            json.options[option.key] = optionStates[option.key][0];
        });

        onChange(JSON.stringify(json));
    }

    return <div>
        <label className="bold"><span className="labelText">{label}</span>
        </label>

        {options.map((option, i) => {
            return <CheckBox state={optionStates[option.key][0]} label={option.value}
                             onChange={(value, isChecked) => onChangeListener(option, value, isChecked)}/>

        })
        }

        {showInput &&
            <input style={{
                maxWidth: '100%',
                width: '250px',
                top: '2px',
                position: 'relative',
                marginLeft: '10px',
            }} className={"select-input-field react-input"} type={"text"}
                   value={inputValue}
                   onChange={(e) => {
                       setInputValue(e.target.value);
                   }}
            />
        }

    </div>

};